<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title-container">
            <span class="desc large">
              <b>Welcome to</b>
            </span>
            <span class="title title-80 text-light-green">BlockWrld</span>
            <span class="desc large">
              <b>!</b>
            </span>
          </div>
          <div class="desc-main desc regular">
            Your gateway to an epic Minecraft server! Each click draws you into
            a vibrant world of adventure, filled with stunning landscapes and
            creative builds.
          </div>
          <button class="button stroke w-230 big" @click="getStarted()">
            Get started
          </button>
        </div>
      </div>
      <div class="section section-2">
        <div class="wrapper">
          <div class="left">
            <div class="title title-88">
              Connecting to BlockWrld is a Breeze!
            </div>
            <div class="desc regular">
              Here’s how to jump into our exclusive Minecraft server:
            </div>
            <div class="desc small">
              Start crafting your BlockWrld story today!
            </div>
          </div>
          <div class="right">
            <div class="list">
              <div class="item">
                <img src="./../images/section2/1.svg" />
                <div class="desc desc-20">
                  Open Minecraft and confirm you’re on the right version (see
                  our <span class="text-dark-green">site</span> for details).
                </div>
              </div>
              <div class="item">
                <img src="./../images/section2/2.svg" />
                <div class="desc desc-20">
                  Navigate to
                  <span class="text-dark-green">[Multiplayer]</span> and select
                  <span class="text-dark-green">[Add Server]</span>.
                </div>
              </div>
              <div class="item">
                <img src="./../images/section2/3.svg" />
                <div
                  class="desc desc-20 desc-copy"
                  v-if="$parent.settings && $parent.settings.game_server"
                >
                  Input "BlockWrld" as the server name and add our IP:<br />
                  <span class="text-dark-green">{{
                    $parent.settings.game_server.host +
                    ":" +
                    $parent.settings.game_server.port
                  }}</span>
                  <button class="copy" @click="copy()">
                    <span class="desc">{{
                      copied ? "Copied" : "Copy IP"
                    }}</span>
                    <img src="./../images/copy.svg" />
                  </button>
                </div>
              </div>
              <div class="item">
                <img src="./../images/section2/4.svg" />
                <div class="desc desc-20">
                  Press <span class="text-dark-green">[Done]</span>, choose
                  BlockWrld from your server list, and click
                  <span class="text-dark-green">[Join Server]</span>.
                </div>
              </div>
              <div class="item">
                <img src="./../images/section2/5.svg" />
                <div class="desc desc-20">
                  Dive into our dynamic world, meet the community, and begin
                  your epic journey!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-3">
        <div class="wrapper">
          <div class="title title-88">What Makes BlockWrld Special</div>
          <div class="list">
            <div class="item">
              <img src="./../images/section3/1.webp" />
              <div class="desc medium">
                <b>SHARE THE FUN</b>
              </div>
              <div class="desc medium">
                Grab the server IP in one click and bring your friends to
                explore BlockWrld’s epic universe together!
              </div>
            </div>
            <div class="item">
              <div class="desc medium">
                <b>YOUR JOURNEY BEGINS WITH A CLICK!</b>
              </div>
              <div class="desc medium">
                Step into the vibrant world of BlockWrld, brimming with unique
                features and endless surprises to uncover!
              </div>
              <img src="./../images/section3/2.webp" />
            </div>
            <div class="item">
              <img src="./../images/section3/3.webp" />
              <div class="desc medium">
                <b>BOUNDLESS CREATIVITY</b>
              </div>
              <div class="desc medium">
                Unleash your imagination in BlockWrld—build, explore, and shape
                your adventure with no limits!
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section-4">
        <div class="wrapper">
          <button class="button w-250 big" @click="getStarted()">
            {{ isAuth ? "Get started" : "Sign up" }}
          </button>
          <div class="desc big">
            today and dive into the boundless adventure of Minecraft on
            BlockWrld!
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: "Home",
  props: ["isAuth"],
  components: {},
  data: function () {
    return {
      activePanels: [],
      copied: false,
    };
  },
  mounted() {},
  methods: {
    copy() {
      let self = this;
      var textarea = document.createElement("textarea");
      textarea.value =
        self.$parent.settings.game_server.host +
        ":" +
        self.$parent.settings.game_server.port;
      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand("copy");

      document.body.removeChild(textarea);
      self.copied = true;

      setTimeout(() => {
        self.copied = false;
      }, 2000);
    },
    getStarted() {
      if (this.isAuth) {
        this.$router.push({ path: "/shop" });
      } else {
        this.$parent.openSignIn();
      }
    },
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1);
      } else {
        this.activePanels.push(index);
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index);
    },
    submit() {
      let data = {
        name: this.name,
        email: this.email,
        message: this.message,
      };
      this.$emit("sendContactForm", data);
    },
  },
};
</script>
